import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // <-- ADDED THIS
import { Menu, X } from 'lucide-react';
import logoImg from '../assets/logo.png'; 

const Navbar = ({ theme }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  const location = useLocation(); // <-- ADDED THIS
  const navigate = useNavigate(); // <-- ADDED THIS

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    const handleResize = () => setIsMobile(window.innerWidth <= 768);

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    
    return () => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleResize);
    };
  }, []);

  // --- NEW: Handles scrolling when arriving from another page ---
  useEffect(() => {
    if (location.pathname === '/' && location.hash) {
      const id = location.hash.replace('#', '');
      // Slight delay ensures the homepage DOM has fully loaded before scrolling
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          const headerOffset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({ top: offsetPosition, behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);

  // --- UPDATED: Context-aware scrolling ---
  const scrollToSection = (id) => {
    setIsMobileOpen(false); 
    
    if (location.pathname !== '/') {
      // 1. If NOT on homepage, navigate to the homepage with a hash (e.g. /#solutions)
      navigate(`/#${id}`);
    } else {
      // 2. If ALREADY on homepage, just scroll smoothly
      const element = document.getElementById(id);
      if (element) {
        const headerOffset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({ top: offsetPosition, behavior: "smooth" });
      }
    }
  };

  const navLinks = [
    { name: 'Solutions', id: 'solutions' },
    { name: 'Features', id: 'features' },
    { name: 'Pricing', id: 'pricing' },
  ];

  // --- STYLES (Unchanged) ---
  const navContainerStyle = {
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
    background: isScrolled || isMobileOpen ? `${theme.navBg}F2` : theme.navBg,
    backdropFilter: isScrolled || isMobileOpen ? 'blur(10px)' : 'none',
    borderBottom: `1px solid ${theme.navBg}`, 
    transition: 'all 0.3s ease',
    padding: '15px 20px',
    boxShadow: isScrolled || isMobileOpen ? '0 4px 20px rgba(0,0,0,0.2)' : 'none' 
  };

  const linkStyle = {
    background: 'none', border: 'none', fontSize: '1rem', fontWeight: '500', 
    color: theme.navText, 
    cursor: 'pointer', fontFamily: 'inherit',
    opacity: 0.9, transition: 'opacity 0.2s',
    padding: isMobile ? '15px 0' : '0', 
    width: isMobile ? '100%' : 'auto',
    textAlign: isMobile ? 'left' : 'center',
    borderBottom: isMobile ? `1px solid rgba(255,255,255,0.05)` : 'none'
  };

  const loginButtonStyle = {
    padding: '10px 24px', borderRadius: '8px', border: 'none', 
    background: theme.primary, color: 'white', fontWeight: 'bold', cursor: 'pointer',
    boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
    width: isMobile ? '100%' : 'auto',
    marginTop: isMobile ? '15px' : '0'
  };

  return (
    <nav style={navContainerStyle}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        
        <div 
          onClick={() => navigate('/')} 
          style={{ display: 'flex', alignItems: 'center', gap: '10px', fontWeight: 'bold', fontSize: '1.2rem', color: theme.navText, cursor: 'pointer' }}
        >
           <img src={logoImg} alt="SiteACT" style={{ height: '36px', width: 'auto' }} />
           <span>SiteACT</span>
        </div>

        {!isMobile && (
            <div style={{ display: 'flex', gap: '30px', alignItems: 'center' }}>
            {navLinks.map(link => (
                <button 
                  key={link.name} 
                  onClick={() => scrollToSection(link.id)}
                  style={linkStyle}
                  onMouseEnter={(e) => e.target.style.opacity = 1}
                  onMouseLeave={(e) => e.target.style.opacity = 0.9}
                >
                  {link.name}
                </button>
            ))}
            <button style={loginButtonStyle} onClick={() => window.location.href='https://login.siteact.app'}>
                Login
            </button>
            </div>
        )}

        {isMobile && (
            <div> 
                <button onClick={() => setIsMobileOpen(!isMobileOpen)} style={{ background: 'none', border: 'none', color: theme.navText, cursor: 'pointer' }}>
                    {isMobileOpen ? <X size={28} /> : <Menu size={28} />}
                </button>
            </div>
        )}
      </div>

      {isMobile && isMobileOpen && (
          <div style={{
              position: 'absolute', top: '100%', left: 0, right: 0,
              background: theme.navBg,
              padding: '10px 20px 30px',
              display: 'flex', flexDirection: 'column',
              boxShadow: '0 10px 20px rgba(0,0,0,0.2)',
              borderBottom: '1px solid rgba(255,255,255,0.1)'
          }}>
              {navLinks.map(link => (
                  <button 
                    key={link.name} 
                    onClick={() => scrollToSection(link.id)}
                    style={linkStyle}
                  >
                    {link.name}
                  </button>
              ))}
              <button style={loginButtonStyle} onClick={() => window.location.href='https://login.siteact.app'}>
                  Login
              </button>
          </div>
      )}
    </nav>
  );
};

export default Navbar;